<template>
  <div>
    <div class="title">{{ $t('유관기관 비상연락망') }}</div>
    <div class="print-container">
      <h5 class="mb-5"><i class="dot"></i>{{ $t('내부 비상연락망') }}</h5>
      <table>
        <colgroup></colgroup>
        <thead>
          <th>{{ $t('구분') }}</th>
          <th>{{ $t('직책') }}</th>
          <th>{{ $t('연락처') }}</th>
          <th>{{ $t('임무 및 역할') }}</th>
          <th>{{ $t('관련 웹사이트') }}</th>
        </thead>
        <tbody>
          <tr v-for="(data, data_i) in form.inside" :key="data_i">
            <td>
              <div>{{ data.input1 }}</div>
            </td>
            <td>
              <div>{{ data.input2 }}</div>
            </td>
            <td>
              <div>{{ data.input3 }}</div>
            </td>
            <td>
              <div>{{ data.input4 }}</div>
            </td>
            <td class="link">
              <div>{{ data.input5 }}</div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="print-container mt-10">
      <h5 class="mb-5"><i class="dot"></i>{{ $t('외부 비상연락망') }}</h5>
      <table>
        <colgroup></colgroup>
        <thead>
          <th>{{ $t('구분') }}</th>
          <th>{{ $t('직책') }}</th>
          <th>{{ $t('연락처') }}</th>
          <th>{{ $t('임무 및 역할') }}</th>
          <th>{{ $t('관련 웹사이트') }}</th>
        </thead>
        <tbody>
          <tr v-for="(data, data_i) in form.outside" :key="data_i">
            <td>
              <div>{{ data.input1 }}</div>
            </td>
            <td>
              <div>{{ data.input2 }}</div>
            </td>
            <td>
              <div>{{ data.input3 }}</div>
            </td>
            <td>
              <div>{{ data.input4 }}</div>
            </td>
            <td class="link">
              <div>{{ data.input5 }}</div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: "Print",
  props: {
    form: Object,
  },
};
</script>
<style lang="scss" scoped>
.title {
  font-size: 24px;
  font-weight: bold;
  line-height: 35px;
  padding: 20px 0;
  margin-bottom: 40px;
}
table {
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;
  th,
  td {
    border: 1px solid #000;
    padding: 15px 0;
    text-align: center;
    border: 1px solid #cdcdcd;
  }

  th {
    font-weight: 500;
    font-size: 14px;
    line-height: 18px;
    color: #3c3c3c;
    background: #f9f9f9;
  }

  td {
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    color: #3c3c3c;
    box-sizing: content-box;

    &.link {
      color: #0085ff;
    }

    div {
      min-height: 18px;
    }
  }
}
</style>
